import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule, Routes} from '@angular/router';
import {NgbDropdownModule, NgbModalModule} from '@ng-bootstrap/ng-bootstrap';

import {CoreCommonModule} from '@core/common.module';

import {ReferralShellComponent} from './referral-shell/referral-shell.component';
import {ReferralDashboardComponent} from './referral-dashboard/referral-dashboard.component';
import {ReferralPartnersComponent} from './referral-partners/referral-partners.component';
import {ReferralListComponent} from './referral-list/referral-list.component';
import {ReferralPayoutsComponent} from './referral-payouts/referral-payouts.component';
import {ReferralKycComponent} from './referral-kyc/referral-kyc.component';
import {ReferralPayoutAccountsComponent} from './referral-payout-accounts/referral-payout-accounts.component';
import {ReferralProgramsComponent} from './referral-programs/referral-programs.component';
import {ReferralCampaignsComponent} from './referral-campaigns/referral-campaigns.component';
import {RefChartComponent} from './shared/ref-chart.component';
import {RefDrawerComponent} from './shared/ref-drawer.component';
import {RefPagerComponent} from './shared/ref-pager.component';
import {RefPromptComponent} from './shared/ref-prompt.component';

const routes: Routes = [
    {
        path: 'referral',
        component: ReferralShellComponent,
        data: {animation: 'referral'},
        children: [
            {path: '', redirectTo: 'dashboard', pathMatch: 'full'},
            {path: 'dashboard', component: ReferralDashboardComponent},
            {path: 'partners', component: ReferralPartnersComponent},
            {path: 'referrals', component: ReferralListComponent},
            {path: 'payouts', component: ReferralPayoutsComponent},
            {path: 'kyc', component: ReferralKycComponent},
            {path: 'payout-accounts', component: ReferralPayoutAccountsComponent},
            {path: 'programs', component: ReferralProgramsComponent},
            {path: 'campaigns', component: ReferralCampaignsComponent}
        ]
    }
];

@NgModule({
    declarations: [
        ReferralShellComponent,
        ReferralDashboardComponent,
        ReferralPartnersComponent,
        ReferralListComponent,
        ReferralPayoutsComponent,
        ReferralKycComponent,
        ReferralPayoutAccountsComponent,
        ReferralProgramsComponent,
        ReferralCampaignsComponent,
        RefChartComponent,
        RefDrawerComponent,
        RefPagerComponent,
        RefPromptComponent
    ],
    imports: [
        CommonModule,
        CoreCommonModule,
        RouterModule.forChild(routes),
        NgbModalModule,
        NgbDropdownModule
    ]
})
export class ReferralModule {
}
